import React from 'react'

import { getInitials } from '../communityUtils'

// The author circle: photo when there is one, otherwise initials on the author's
// deterministic color (same color math as the mobile app).
export default function PostAvatar({ name, picture, color, size = 40 }) {
  if (picture) {
    return (
      <img
        src={picture}
        alt={name || 'Member'}
        className='rounded-full object-cover shrink-0'
        style={{ width: size, height: size }}
      />
    )
  }

  return (
    <div
      className='rounded-full flex items-center justify-center shrink-0'
      style={{ width: size, height: size, backgroundColor: color || '#4dba97' }}
    >
      <span className='text-white font-bold' style={{ fontSize: size * 0.38 }}>
        {getInitials(name)}
      </span>
    </div>
  )
}
